export default __webpack_public_path__ + "static/img-2-fce80d18fc370ba69beb66a3aa72e770.png";